
import { useState } from 'react';
import Button from '../base/Button';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-4">
            <div className="flex flex-col items-center">
              <img 
                src="https://static.readdy.ai/image/cf4f27e07b239285bf21e11bcbee378e/8703acdd619c7d120ad1a5ed69e04cf5.png" 
                alt="Shadowfax Roofing Logo" 
                className="h-12 w-auto mb-1"
              />
              <div className="text-xl font-bold text-gray-800" style={{ fontFamily: 'Pacifico, serif' }}>
                Shadowfax Roofing
              </div>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-12">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium cursor-pointer"
            >
              Contact
            </button>
            <Button variant="primary" className="bg-blue-600 hover:bg-blue-700">
              (408) 628-0065
            </Button>
          </div>

          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 cursor-pointer"
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4">
            <div className="flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-blue-600 transition-colors font-medium text-left cursor-pointer"
              >
                Contact
              </button>
              <Button variant="primary" className="bg-blue-600 hover:bg-blue-700 w-fit">
                (408) 628-0065
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
